"use client";
import { Dialog } from "@base-ui/react/dialog";
import { XIcon } from "lucide-react";
import type { BodyMassIndexResponse } from "../../_components/types";

interface ResultDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  result: BodyMassIndexResponse | null;
}

export const ResultDialog = ({
  open,
  onOpenChange,
  result,
}: ResultDialogProps) => {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm transition-opacity" />
        <Dialog.Popup className="fixed top-1/2 left-1/2 z-50 flex w-[90vw] max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-3xl bg-white shadow-2xl outline-none overflow-hidden">
          <div className="flex items-center justify-between px-6 py-4">
            <Dialog.Title className="text-xl font-bold text-gray-900">
              Beden Kitle İndeksi Hesaplama
            </Dialog.Title>
            <Dialog.Close className="rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
              <XIcon className="size-5" />
            </Dialog.Close>
          </div>

          <div className="bg-linear-to-b from-teal-100 to-white flex justify-center py-8">
            <div
              className="flex flex-col items-center justify-center rounded-full size-36 text-white"
              style={{ backgroundColor: result?.categoryColor ?? "#5aab8e" }}
            >
              <span className="text-5xl font-bold leading-none">
                {result?.value ?? "-"}
              </span>
              <span className="text-base mt-1">
                {result?.categoryLabel ?? ""}
              </span>
            </div>
          </div>

          {result ? (
            <div className="px-6 pt-2 pb-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                {result.description}
              </p>
            </div>
          ) : (
            <p className="px-6 py-4 text-sm text-gray-500">Sonuç bulunamadı.</p>
          )}

          <div className="px-6 pb-6 pt-2">
            <hr className="border-gray-200 mb-4" />
            <Dialog.Close className="w-full rounded-full bg-[#3b82c4] py-4 text-base font-semibold text-white transition-colors hover:bg-[#2d6ea8]">
              Tekrar Hesapla
            </Dialog.Close>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
